import React, { memo, useCallback } from "react";
import { setContent } from "./state/content";
const Trigger = /*#__PURE__*/memo(({
  align,
  trigger,
  children,
  ...props
}) => {
  const onMouseDown = useCallback(e => {
    e.stopPropagation();
    setContent({
      children,
      align,
      style: {
        top: e.pageY,
        left: e.pageX
      }
    });
  }, [align, children]);
  return /*#__PURE__*/React.cloneElement(trigger, {
    onMouseDown,
    ...props
  });
});
Trigger.defaultProps = {
  align: "top left"
};
export default Trigger;
//# sourceMappingURL=Trigger.js.map